var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "k-site-header" }, [
    _c(
      "div",
      { staticClass: "header-content" },
      [
        _vm._t("logo"),
        _vm._t(
          "title",
          function () {
            return [
              _c(
                "h1",
                { staticClass: "site-title" },
                [
                  _c(
                    "router-link",
                    { staticClass: "text-link", attrs: { to: "/" } },
                    [_vm._v(_vm._s(_vm.siteTitle))]
                  ),
                ],
                1
              ),
            ]
          },
          { title: _vm.siteTitle }
        ),
        _vm.menus.site
          ? _c(
              "nav",
              { staticClass: "site-menu desktop-only" },
              _vm._l(_vm.menus.site, function (item) {
                return _c("router-link", {
                  key: item.id,
                  attrs: { to: item.url },
                  domProps: { innerHTML: _vm._s(item.title) },
                })
              }),
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "spacer mobile-only" }),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c("w-search"),
            _vm.isDeveloper
              ? _c(
                  "w-btn-icon",
                  {
                    attrs: { size: "lg2" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.openDeveloper.apply(null, arguments)
                      },
                    },
                  },
                  [_c("i-coffee")],
                  1
                )
              : _vm._e(),
            _c("w-btn-user"),
          ],
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }